<template>
  <layout>
    <rdkm-title>
      {{ $t('Акты') }}
      <span class="d-flex float-right"> 
        <user-accessible routerName="CertificateEdit">
          <b-button @click="scan" right size="sm" class="mr-4" variant="primary">
            <font-awesome-icon icon="sync" />
            {{ $t('Сканировать') }}
          </b-button>          
          <router-link tag="span" to="/certificates/add">
            <b-button right size="sm" class="mr-4" variant="primary">
              <font-awesome-icon icon="plus" />
              {{ $t('Добавить') }}
            </b-button>
          </router-link>
          <b-button v-show="false" @click="showReportModal" right size="sm" variant="secondary">
            <font-awesome-icon icon="download" />
            {{ $t('Отчет') }}
          </b-button>
        </user-accessible>
      </span>
    </rdkm-title>
    <div class="tile">
      <filter-form
        :certificateNumberFrom="filterQuery.certificateNumberFrom"
        :certificateNumberTo="filterQuery.certificateNumberTo"
        :receiptInFrom="filterQuery.receiptInFrom"
        :receiptInTo="filterQuery.receiptInTo"
        :receiptInLaboratoryFrom="filterQuery.receiptInLaboratoryFrom"
        :receiptInLaboratoryTo="filterQuery.receiptInLaboratoryTo"
        :biomaterialSampleIds="filterQuery.biomaterialSampleIds"
        :entryType="filterQuery.entryType"
        :incomeCity="filterQuery.incomeCity"
        :entryMedicalOfficeId="filterQuery.entryMedicalOfficeId"
        :entryActionId="filterQuery.entryActionId"
        :isPriority="filterQuery.isPriority"
        v-on:reset="$refs.grid.filter(reset)"
        v-on:search="$refs.grid.filter($event, true)"
      >
      </filter-form>
      <rdkm-grid
        ref="grid"
        :state="filterQuery"
        :class="'certificate-form-grid'"
        :emptyDataLabel="$t('Отсутствуют акты')"
        :url-prefix="'pmdd'"
      >
      <grid-column
          name="number"
          :title="$t('Номер акта')"
          width="120"
          cell="edit-cell"
          :className="(row) => getWarningClass(row)"
          :url="(row) => `/certificates/${row.id}`"
        ></grid-column>
        <grid-column
          :title="$t('Дата поступ. в орг.')"
          width="190"
          :className="(row) => getWarningClass(row)"
          name="receipt_in_ano_at"
          :format="date => date ? moment(date).format('DD.MM.YYYY') : ''"
        ></grid-column>
        <grid-column
          :title="$t('Дата поступ. в лаб.')"
          :className="(row) => getWarningClass(row)"
          width="190"
          name="receipt_in_laboratory_at"
          :format="date => date ? moment(date).format('DD.MM.YYYY') : ''"
        ></grid-column>
        <grid-column
          :title="$t('Образец')"
          :className="(row) => getWarningClass(row)"
          width="250"
          name="biomaterial_sample_name"
        ></grid-column>
        <grid-column
          :title="$t('Откуда поступило')"
          :className="(row) => getWarningClass(row)"
          width="200"
          name="entry_type_name"
        ></grid-column>
        <grid-column
          :title="$t('Акция')"
          :className="(row) => getWarningClass(row)"
          width="200"
          name="entry_action_name"
        ></grid-column>
        <grid-column
          :title="$t('Мед. учреждение')"
          :className="(row) => getWarningClass(row)"
          width="200"
          name="entry_medical_office_name"
        ></grid-column>
        <grid-column
          :title="$t('Кол-во анкет')"
          :className="(row) => getWarningClass(row)"
          width="200"
          name="donors_count"
        ></grid-column>
        <grid-column
          key="created_at"
          :title="$t('Дата создания')"
          :className="(row) => getWarningClass(row)"
          width="170"
          name="created_at"
          :format="date => date ? moment(date).format('DD.MM.YYYY') : ''"
        ></grid-column>
        <grid-column
          key="edited_at"
          :title="$t('Дата изменения')"
          :className="(row) => getWarningClass(row)"
          width="170"
          name="edited_at"
          :format="date => date ? moment(date).format('DD.MM.YYYY') : ''"
        ></grid-column>
      </rdkm-grid>
    </div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    >
    <div class="progress certificate-progress">
            <div
              class="progress-bar progress-bar-striped progress-bar-animated bg-success"
              role="progressbar"
              style="width: 100%"
              aria-valuenow="100"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              {{ $t('Подождите, идет обработка...') }}
            </div>
            </div>
    </loading>
    <b-modal
      size="xl"
      @hidden="$emit('closeModal')"
      id="export-certificate-report-modal"
      :title="$t('Отчет по актам')"
      :ok-disabled="true"
      :cancel-disabled="true"
    >
      <div class="export-modal">
        <rdkm-date-picker
          :labelCols="12"
           :notAfter="Date.now()"
          :label="$t('Дата поступ. в орг. с:')"
          :clearable="false"
          v-model="dateFrom"
        ></rdkm-date-picker>
        <rdkm-date-picker
          :labelCols="12"
           :notAfter="Date.now()"
          :label="$t('Дата поступ. в орг. по:')"
          :clearable="false"
          v-model="dateTo"
        ></rdkm-date-picker>
      </div>
      <div slot="modal-footer" class="w-100">
        <div>
          <b-button
            size="sm"
            @click="exportReport"
            variant="primary"
            class="mr-4"
          >
            <font-awesome-icon icon="download" />
            {{ $t('Экспортировать') }}
          </b-button>
          <b-button @click="$root.$emit('bv::hide::modal', 'export-certificate-report-modal')" size="sm" variant="default">
            <font-awesome-icon icon="times" /> {{ $t('Отмена') }}
          </b-button>
        </div>
        <div class="clearfix"></div>
      </div>
    </b-modal>
  </layout>
</template>

<script>
import Loading from 'vue-loading-overlay';
import FilterForm from './Filter.vue';
import Grid from '../../components/grid/Grid.vue';
import GridColumn from '../../components/grid/GridColumn.vue';
import Constants from '../../constants';
import axios from 'axios';

export default {
  props: ['query'],
  components: {
    'filter-form': FilterForm,
    'rdkm-grid': Grid,
    'grid-column': GridColumn,
    Loading,
  },
  provide() {
    return {
      parentValidator: this.$validator,
    };
  },
  data() {
    return {
      dateFrom: '',
      dateTo: '',
      isLoading: false,
      filterQuery: {},
    };
  },
  beforeMount() {
    this.filterQuery = Object.assign({}, this.query);
  },
  computed: {
    downloadReportUrl: function() {
      return Constants.baseUrl + "/pmdd/Reports/GetCertificatesReport";
    },
    reset: function() {
      return {
        };
    },
  },
  methods: {
    getWarningClass(row) {
      if(row.fact_donors_count != row.donors_count) {
        return 'certificate-warning';
      }
      return '';
    },
    scan: function() {
      let self = this;
      this.isLoading = true;
      axios.post("/pmdd/certificates/scan")
      .then((response) => {
        this.isLoading = false;
        const div = document.createElement("div");
        let buttons = {
            ok: {
                className: "btn-primary",
                text: 'Загрузить акты',
                value: "ok"
            },
            cancel: 'Отмена'
        };
        if (response.data.has_errors || response.data.is_empty) {
          buttons = { cancel: 'Ok' };
        }
        div.innerHTML = response.data.message;
        this.$swal({
            content: div,
            icon: "warning",
            buttons: buttons
            }).then(value => {
                if(value === "ok") {
                  self.isLoading = true;
                  axios.post("/pmdd/certificates/create", response.data)
                  .then(() => {
                    self.isLoading = false;
                    self.$swal("", self.$t('Акты успешно загружены!'), "success");
                    self.$refs.grid.refreshGrid(this.$route.fullPath);
                  }).catch(error => { 
                    self.$swal("", error.data.message, "error");
                    self.isLoading = false;
                  });
                }
            });
      });
    },

    showReportModal: function() {
      this.$root.$emit('bv::show::modal', 'export-certificate-report-modal');
    },

    exportReport: function() {
      let self = this;
      let from = this.dateFrom ? this.moment(this.dateFrom).format('YYYY-MM-DD') : '';
      let to = this.dateTo ? this.moment(this.dateTo).format('YYYY-MM-DD') : '';
      this.isLoading = true;
      self.$root.$emit('bv::hide::modal', 'export-certificate-report-modal');
      axios({
        url: this.downloadReportUrl + '?dateFrom=' + from + '&dateTo=' + to,
        method: 'POST',
        responseType: 'blob',
      })
      .then((response) => {
        self.isLoading = false;
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        const fileName = `Акты_${self.moment().format('YYYYMMDD')}.xlsx`;
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
      })
    }
  },
};
</script>
